{
  "name": "client-app",
  "version": "2026.9.0.615",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "test:headless": "ng test --watch=false --browsers=ChromeHeadless",
    "lint": "ng lint",
    "credits": "node scripts/generate-credits.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.3",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "^22.2.3",
    "@angular/material": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@jsverse/transloco": "^8.4.0",
    "angular-code-input": "^2.0.0",
    "marked": "~18.0.14",
    "ngx-mat-select-search": "^9.0.0",
    "rxjs": "~7.8.1",
    "tslib": "^2.8.0",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.6.0",
    "@angular-eslint/eslint-plugin": "^22.6.0",
    "@angular-eslint/eslint-plugin-template": "^22.6.0",
    "@angular-eslint/schematics": "22.6.0",
    "@angular-eslint/template-parser": "^22.6.0",
    "@angular/build": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@playwright/test": "~1.63.0",
    "@types/jasmine": "~5.1.15",
    "@types/node": "^24.19.2",
    "@typescript-eslint/eslint-plugin": "^8.71.0",
    "@typescript-eslint/parser": "^8.71.0",
    "angular-eslint": "^22.6.0",
    "baseline-browser-mapping": "~2.11.28",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "^8.10.0",
    "eslint-plugin-prettier": "^4.2.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.13.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "license-checker-rseidelsohn": "^5.0.1",
    "prettier": "2.8.8",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.0"
  }
}
